import { forwardRef } from 'react';

import type { IconProps } from './types';

/*
 * DO NOT remove `forwardRef`
 * It is used for `motion.create`
 */
const Tick = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg width="24" height="24" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" {...props} ref={forwardedRef}>
    <path
      d="M949.197 130.799a78.815 78.815 0 0 0-1.608-.017c-20.531 0-39.166 8.114-52.874 21.312l.024-.024-580.831 559.048-184.647-177.84c-13.693-13.22-32.358-21.366-52.928-21.366-21.584 0-41.073 8.969-54.943 23.383l-.024.024C8.146 549.012 0 567.677 0 588.247c0 21.584 8.969 41.073 23.383 54.943l.024.024 237.744 228.725c13.683 13.169 32.316 21.28 52.841 21.28s39.159-8.111 52.865-21.302l-.024.024 633.758-609.932c14.438-13.894 23.409-33.383 23.409-54.967 0-20.57-8.145-39.235-21.387-52.95l.022.022c-13.558-14.05-32.425-22.901-53.361-23.313l-.077-.002z"
      fill={color}
    />
  </svg>
));

export default Tick;
